
import axios from "axios";


export const api = axios.create({ baseURL: process.env.REACT_APP_API });
export const weatherApi = axios.create({ baseURL: process.env.REACT_APP_WEATHERAPI });

// LOGIN PAGE API
export const LOGIN = (data) => api.post("/api/auth/login", data);

// FORGOT PAGE APIss
export const FORGOTPASS = (data) => api.post("/api/auth/forget-password", data);

// DASHBOARD API
export const DASHBOARD = (header) => api.get("/api/admin/get/dashboard/details/data", header);

// ENTERPRISE PAGE TABLE API
export const ENTERPRISETABLE = (header) => api.get("/api/admin/get/enterprise/list/data", header);

// ADD ENTERPRISE MODEL PAGE API
export const ADDENTERPRISE = (data, header) => api.post("/api/admin/add/enterprise", data, header);

// EDIT ENTERPRISE
export const EDITENTERPRISE = (EnterpriseId, data, header) => api.post(`/api/admin/update/enterprise/${EnterpriseId}`, data, header);

// EDIT ENTERPRISE
export const GETALLENTERPRISE = (header) => api.get(`api/admin/get/enterprise`, header);

// STATE TABLE API
export const STATETABLE = (EnterpriseId, header) => api.get(`/api/admin/get/enterprise/state/list/${EnterpriseId}`, header);

// STATE MODEL
export const ADDSTATELIST = (header) => api.get(`/api/admin/get/all/states`, header);

//    ADD STATE MODEL
export const ADDSTATE = (data, header) => api.post(`/api/admin/add/enterprise/state`, data, header);

// LOCATION TABLE API
export const LOCATIONTABLE = (EnterpriseId, StateId, header) => api.get(`/api/admin/get/enterprise/state/location/list/${EnterpriseId}/${StateId}`, header);

// ADD LOCATION MODEL
export const ADDLOCATION = (data, header) => api.post(`/api/admin/add/enterprise/state/location`, data, header);

// GATEWAY TABLE API
export const GATEWAYTABLE = (LocationId, header) => api.get(`/api/admin/get/enterprise/state/location/gateway/list/${LocationId}`, header);

// ADD GATEWAY 
export const GATEWAYMODEL = (data, header) => api.post(`/api/admin/add/gateway`, data, header);

// GATEWAY DETAILS
export const GATEWAYDETAILS = (Gateway_ID, header) => api.get(`/api/admin/get/gateway/details/${Gateway_ID}`, header);

// EDIT GATEWAY
export const EDITGATEWAY = (GatewayId, data, header) => api.post(`/api/admin/update/gateway/${GatewayId}`, data, header);

// OPTIMIZER TABLE API
export const OPTIMIZERTABLE = (GatewayId, header) => api.get(`/api/admin/get/enterprise/state/location/gateway/optimizer/list/${GatewayId}`, header);

// ADD OPTIMIZER
export const ADDOPTIMIZER = (data, header) => api.post(`/api/admin/add/optimizer`, data, header);

//EDIT OPTIMIZER
export const EDITOPTIMIZER = (OptimizerId, data, header) => api.post(`/api/admin/update/optimizer/${OptimizerId}`, data, header);

// OPTIMIZERDETAILS
export const OPTIMIZERDETAILS = (optimizerId, header) => api.get(`/api/admin/get/optimizer/details/${optimizerId}`, header);

// USER PAGE TABLE LIST API
export const USERAPILIST = (header) => api.get("/api/admin/get/user/data", header);

// USER ADD ENTERPRISEuSER PAGE MODEL API
export const ADDENTERPRISELIST = (data, header) => api.post("/api/admin/add/enterprise/user", data, header);

// USER ENTERPRISE LIST NAME MODEL API
export const ENTERPRISEUSERLIST = (header) => api.get("/api/admin/get/enterprise/list/name", header);

// USER ADD SYSTEM INTEGRATOR PAGE MODEL API
export const ADDSYSTEMINTEGRATOR = (userData, header) => api.post("/api/admin/add/system/integrator", userData, header);

// USER DELETE
export const USERDELETE = (Id, header) => api.post(`/api/admin/delete/user/${Id}`, {}, header);

// Settings
export const SET = (data, header) => api.post(`/api/hardware/optimizer/setting/value/update`, data, header);
export const RESET = (Data, header) => api.post(`/api/hardware/reset/optimizer`, Data, header);
export const GETCURRENTDATA = (OptimizerId, header) => api.post(`/api/hardware/get/optimizer/current/settings/${OptimizerId}`, {}, header);

// BY PASS
export const BYPASS = (data, header) => api.post(`/api/hardware/bypass/optimizers`, data, header);
export const SCHEDULE_BYPASS = (data, header) => api.post(`/api/hardware/bypass/optimizers`, data, header);
export const INSTANT_BYPASS_ONOFF = (data, header) => api.post(`/api/hardware/bypass/optimizers`, data, header);
export const CANCEL_SCHEDULE_BYPASS = (data, header) => api.post(`/api/hardware/bypass/optimizers`, data, header);

//BY PASS LISTING
// export const BYPASS_LIST = (EnterpriseId, data, header) => api.get(`/api/bypass/enterprise/bypass/data/${EnterpriseId}`, data, header);
export const BYPASS_LIST = (data, header) => api.post(`/api/bypass/enterprise/bypass/data`, data, header);
export const BYPASS_SCHEDULE = (data, header) => api.post(`/api/hardware/bypass/schedule`, data, header);
export const DELETE_BYPASS = (data, header) => api.post(`/api/hardware/bypass/delete`, data, header);
export const TURN_ONOFF_BYPASS = (data, header) => api.post(`/api/hardware/bypass/onoff`, data, header);
export const BYPASS_HISTORY = (data, header) => api.post(`/api/hardware/bypass/history`, data, header);

//DELETE
export const DELETE = (deleteData, header) => api.post(`/api/admin/delete/all`, deleteData, header);

//Report
export const METERDATA = (Page, data, header) => api.post(`/api/admin/get/all/meter/data?page=${Page.page}&flag=${Page.flag}&PrevTimeStamp=${Page.PrevTimeStamp}&pageSize=100`, data, header);
export const DEVICEDATA = (Page, data, header) => api.post(`/api/admin/get/all/device/data?page=${Page.page}&flag=${Page.flag}&PrevTimeStamp=${Page.PrevTimeStamp}pageSize=20`, data, header);
export const AMBIENTDATA = ( data, header) => api.post(`/api/admin/get/all/ambient/data`, data, header);
export const AMBIENTDATADOWNLOAD = ( data, header) => api.post(`/api/admin/get/all/ambient/data/download`, data, header);
export const TABLEGRAPH = (data, header) => api.post(`/api/admin/get/all/usage/trends`, data, header);
export const ACONOFF = (data, header) => api.post(`/api/admin/get/all/acon/off`, data, header);
export const E_METERDATA = (data, header) => api.post(`/api/admin/get/all/e_meter/data`, data, header);

//Deloitte Data
export const CONFIGS = (data, header) => api.post(`/api/deloitte/data/gatewayandoptimizerData`, data, header);
export const ENERGYMETER = (data, header) => api.post(`/api/deloitte/data/energymeterData`, data, header);
export const AMBIENTINFO = (data, header) => api.post(`/api/deloitte/data/ambientData`, data, header);
export const ACSTATUS = (data, header) => api.post(`/api/deloitte/data/aconoffData`, data, header);
export const BYPASSDATA = (data, header) => api.post(`/api/deloitte/data/bypassData`, data, header);
export const DELOITTELINKS = (data, header) => api.post(`/api/deloitte/data/deloitteLinks`, data, header);


// FOTA
export const FW_VERSION = (data, header) => api.get(`/api/ota/fetch/metadata`, data, header);
export const OTA = (data, header) => api.post(`/api/ota/firmware/update`, data, header);
export const FOTA_STATUS = (gatewayId, header) => api.get(`/api/ota/fota/status?gatewayID=${gatewayId}`, header);

//Energymeter API
export const ENERGYMETERAPI = (data, header) => api.post(`/api/admin/get/all/energymeter/data`, data, header);

// Inverter AC Device (test_data)
export const TEST_DATA_DEVICES = () => api.get(`/api/test_data/devices`);
export const TEST_DATA_RECORDS = (params) => api.get(`/api/test_data/records`, { params });
// ACCUWEATHER
export const WEATHER = (LocationKey) => weatherApi.get(`/currentconditions/v1/${LocationKey}?apikey=iV4ZAgc5DoSoc3EiDciIas8ePgSn7lH5&details=true`);

export const LOCATIONAPIKEY = (coordinate) => weatherApi.get(`/locations/v1/cities/geoposition/search?apikey=iV4ZAgc5DoSoc3EiDciIas8ePgSn7lH5&q=${coordinate.Lat},${coordinate.Long}`);